import { Button } from 'antd';
import useComicImageAnimations from './useComicImageAnimations.hook';
import { StyledComicImageAnimations } from './ComicImageAnimations.styled';
import Image from 'next/image';

export default function ComicImageAnimations({
  playerState,
  detectedCues,
  animations,
  onAnimationsReady,
  reset,
}) {
  const { state, actions, handleAnimationLoad } = useComicImageAnimations({
    playerState,
    detectedCues,
    animations,
    onAnimationsReady,
    reset,
  });
  console.log(
    `[ preloaded ]: ${state.preloadStatus.loaded} / ${state.preloadStatus.total}`
  );
  return (
    <StyledComicImageAnimations
      style={{
        width: `${playerState.imgPixelSize?.width}px`,
        height: `${playerState.imgPixelSize?.height}px`,
      }}
    >
      {state.staticImages.map((image, index) => {
        return image.src ? (
          <div
            key={`static_${index}`}
            className="first-frame"
            style={{
              opacity: image.boxId > state.currentAnimationId ? 1 : 0,
            }}
          >
            <Image src={image.src} layout="fill" objectFit="cover" alt="" />
          </div>
        ) : null;
      })}
      {state.visibleAnimations.map((animation, index) => (
        <div key={index + '_' + state.reRenderKey} className="animation">
          <Image
            src={animation.src}
            key={state.reRenderKey}
            layout="fill"
            objectFit="cover"
            alt=""
            onLoadingComplete={() => handleAnimationLoad(animation.boxId)}
          />
        </div>
      ))}
    </StyledComicImageAnimations>
  );
}
